import React, { Fragment, useState } from 'react';
import { getBackgroundImg, getPublicImagePath, useAppState } from '@nutastic/nutastic-react-app';
import Fade from 'react-reveal/Fade';
import StoryModal from '../StoryModal';

const HomePage = () => {
    const componentClass = 'home-page';
    const { page: { content: herContent, field_1: hisContent } } = useAppState();
    const [sheIsOpen, setSheIsOpen] = useState(false);
    const [heIsOpen, setHeIsOpen] = useState(false);

    return <Fragment>
        <section className={`${componentClass}__banner`}>
            <div className="bannerImg animated fadeIn delay-1s" style={getBackgroundImg(getPublicImagePath('home_background-2.jpg'))} />
            <div className="overlay" />
            <div className="container h-100">
                <div className={`${componentClass}__subtitle isCursive`}>timeless love</div>
                <h1 className={`${componentClass}__title-header`}>Chelsi &amp; Spencer</h1>
                <div className={`${componentClass}__subtitle hasBars animated fadeInUp delay-1s`}>02.04.23</div>
            </div>
        </section>

        <section className="aboutSection">
            <Fade>
                <div className="container">
                    <h5>"So they are no longer two, but one flesh. Therefore what God has joined together, let no one seperate."</h5>
                    <h5 className="mt-4">- Matthew 19:6 -</h5>
                    <h1>Celebrate With Us As We Become One</h1>
                    <div className="icon-divider">
                        <i className="ion-md-heart" />
                    </div>
                    <p className="aboutSection__blurb">
                        Monte & Sharon Pinkett along with Phillip & Louise Johnson joyfully request the pleasure of your company at the
                         wedding of their children Chelsi Monét & Spencer Napoleon.
                    </p>
                    <div className="aboutSection__buttons">
                        <a href="/about" className="btn btn-outline-white">Wedding Details</a>
                        <a href="/reserve" className="btn btn-white">RSVP</a>
                    </div>
                </div>
            </Fade>
        </section>

        <section className="storySection">
            <Fade left={true}><div className="storySection__image" style={getBackgroundImg(getPublicImagePath('herStory.jpg'))} /></Fade>
            <Fade delay={250}>
                <div className="storySection__details background-black">
                    <h1 className="isCursive">Her Story</h1>
                    <div className="icon-divider">
                        <i className="ion-md-heart-half" />
                    </div>
                    <p>
                        My first introduction to Spencer was freshman year at a basketball game. My cheerpals, Chasity & Shalina, told me
                         that Spence thought I was cute and wanted to talk to me. They pointed him out on the sideline and I said he was
                         cute. We went back to cheering and I didn't think twice about it… and that's where the story ends until senior year...
                    </p>
                    <button className="btn btn-outline-white" onClick={() => setSheIsOpen(true)}>Read More</button>
                </div>
            </Fade>
        </section>

        <section className="storySection storySection--him">
            <Fade right={true}><div className="storySection__image" style={getBackgroundImg(getPublicImagePath('hisStory.jpg'))} /></Fade>
            <Fade delay={250}>
                <div className="storySection__details background-black">
                    <h1 className="isCursive">His Story</h1>
                    <div className="icon-divider">
                        <i className="ion-md-heart-half" />
                    </div>
                    <p>
                        I first saw the now "love of my life" during a basketball game. It was during a timeout that I pointed out to my
                         teammate that pretty brown cheerleader that I had never seen before. "Wiley" I said, "Now that's a wifey type right
                         there." We were only able to glance a second after that before it was...
                    </p>
                    <button className="btn btn-outline-white" onClick={() => setHeIsOpen(true)}>Read More</button>
                </div>
            </Fade>
        </section>

        <section className="rsvpSection">
            <div className="rsvpSection__weddingDetails">
                <Fade bottom={true}><h2>Gallery</h2></Fade>
                <div className="icon-divider">
                    <i className="ion-md-camera" />
                </div>
                <p>Check out the engagement photos of the bride and groom.</p>
                <a href="/gallery" className="btn btn-primary">View Photos</a>
            </div>
            <div className="rsvpSection__booking">
                <Fade bottom={true}><h2>Invitation Responses</h2></Fade>
                <div className="icon-divider">
                    <i className="ion-md-paper-plane" />
                </div>
                <p>Indicate your RSVP by clicking below.</p>
                <a href="/reserve" className="btn btn-white">RSVP</a>
            </div>
        </section>

        <StoryModal isOpen={sheIsOpen} onClose={() => setSheIsOpen(false)} title="Her Story" content={herContent} />
        <StoryModal isOpen={heIsOpen} onClose={() => setHeIsOpen(false)} title="His Story" content={hisContent} />

    </Fragment>;
};

export default HomePage;
